import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { SERVER_API_URL } from '../../../app.constants';
import { Observable } from 'rxjs';
import { ParamContext } from '../../../shared/service/param.context';
import { SampleGenotypeImportRequest } from './sample-genotype-import-request';
import { SampleGenotypeModel } from './sample-genotype.model';
import { ObservationVariable } from '../../../shared/model/observation-variable.model';
import { SampleGenotypeSearchRequestDTO } from './sample-genotype-search-request.model';
import { map } from 'rxjs/operators';
import { PaginatedResponse } from '../../../shared/study/service/study-entry.service';
import { EnableLoadingIndicator, EnableSavingIndicator } from '../../../shared/loading-indicator';

@Injectable({ providedIn: 'root' })
export class SampleGenotypeService {

    constructor(
        private http: HttpClient,
        private context: ParamContext
    ) {
    }

    importSampleGenotypes(studyId: string, sampleListId: string, genotypes: SampleGenotypeImportRequest[]): Observable<HttpResponse<number[]>> {
        return this.http.post<any>(SERVER_API_URL + `crops/${this.context.cropName}/programs/${this.context.programUUID}/studies/${studyId}/samples/genotypes/${sampleListId}`,
            genotypes, { observe: 'response', context: new HttpContext().set(EnableSavingIndicator, true) });
    }

    searchSampleGenotypes(studyId: number, genotypeSearchRequest: SampleGenotypeSearchRequestDTO, page: number, pageSize: number, sort: string): Observable<PaginatedResponse<SampleGenotypeModel>> {
        let url = SERVER_API_URL + `crops/${this.context.cropName}/programs/${this.context.programUUID}/studies/${studyId}/samples/genotypes/table`;
        genotypeSearchRequest.studyId = studyId;

        if (page !== undefined && pageSize !== undefined) {
            url += '?page=' + page + '&size=' + pageSize;
        }
        if (sort !== undefined) {
            url += '&sort=' + sort;
        }
        return this.http.post<PaginatedResponse<SampleGenotypeModel>>(url, genotypeSearchRequest, { observe: 'response', context: new HttpContext().set(EnableLoadingIndicator, true)  }).pipe(
            map(response => {
                return {
                    data: response.body || [],
                    filteredCount: Number(response.headers.get('X-Filtered-Count')),
                    totalCount: Number(response.headers.get('X-Total-Count')),
                    page: page,
                    size: pageSize
                } as PaginatedResponse<SampleGenotypeModel>;
            })
        );
    };

    getColumns(studyId: number, sampleListIds: number[]) {
        const url = SERVER_API_URL + `crops/${this.context.cropName}/programs/${this.context.programUUID}/studies/${studyId}/samples/genotypes/table/columns?sampleListIds=${sampleListIds.join(',')}`;
        return this.http.get<ObservationVariable[]>(url, { context: new HttpContext().set(EnableLoadingIndicator, true) });
    };

}


